import { useEffect } from 'react';
import { appLog } from '../lib/appLog';

/**
 * One app_logs row per settled search (search.<where>), so "should searches be saved?" can be answered from how often
 * people repeat one (Sam, 2026-10-28). Settled = unchanged for 1.5 s, so a half-typed name is not logged. app_logs keeps
 * seven days.
 */
export function useSearchLog(where, query) {
  useEffect(() => {
    const q = String(query || '')
      .trim()
      .toLowerCase();
    if (q.length < 2) return undefined;
    const t = setTimeout(() => appLog('info', `search.${where}`, { q }), 1500);
    return () => clearTimeout(t);
  }, [where, query]);
}
